<template>
  <v-text-field
    readonly
    :value="getIngredientsAllergens.join(', ')"
    outlined
    hide-details
    prepend-icon="fa-notes-medical"
  ></v-text-field>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeAllergensDisplay",
  props: {
    ingredients: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getOrganisationId"]),
    getIngredientsAllergens() {
      return [
        ...new Set(
          this.ingredients
            .filter(x => x.is_deleted === false)
            .map(x => {
              if (
                this.getProducts.find(p => p.id === x.pk_recette_produit) &&
                this.getProducts.find(p => p.id === x.pk_recette_produit).data
              ) {
                const product = this.getProducts.find(
                  p => p.id === x.pk_recette_produit
                );
                if (product.data.allergens.length > 0) {
                  return product.data.allergens;
                } else {
                  return [];
                }
              }
            })
            .flat()
        )
      ].filter(x => x !== undefined);
    }
  }
};
</script>

<style></style>
